let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("20iJq")).then(() => parcelRequire('40feu'));